export const getCarData = `
  query GetBusinessCarData($licensePlate: String!) {
    businessCarData(licensePlate: $licensePlate) {
      motorVehicle {
        licensePlate
        reportCode
        make
        model
        modelVersion
        constructionMonth
        constructionYear
        weightInKg
        currentVehicleColors
        fuel
        secondFuelType
        cylinderCapacityInInCubicCentimeters
        numberOfKilowatts
        transmissionType
        consumerPriceIncludingVat
        consumerPriceExcludingVat
        leaseFinancingRent
        presentTnoScmVehicleSecurityClass
        rdwVehicleCategory
        advice
        reason
        documents {
          attachmentDescription
          urlAttachment
        }
      }
    }
  }
`;
